<template>
    <div>
        <hts-card
            :title="$t('labels.invoiceInformation')"
            :loading="loaded">
            <template
                v-if="group.isAdmin || permissions.includes('company_edit_invoice')"
                #actions>
                <hts-dropdown
                    :options="dropdownOptions"
                    type="text"
                    :label-only-icon="true"
                    color="theme"
                    size="large"
                    prop-option-key="id"
                    prop-option-label="name"
                    icon="hi-ellipsis-vertical-icon"
                    prop-option-icon="hi-pencil-alt-icon"
                    @click="handleEditInvoice" />
            </template>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-5">
                <div>
                    <h3>
                        {{ $t('labels.companyName') }}
                    </h3>
                    <p class="mt-2">
                        {{ companyName }}
                    </p>
                </div>
                <div>
                    <h3>
                        {{ $t('labels.invoiceName') }}
                    </h3>
                    <p class="mt-2">
                        {{ invoicingData.name }}
                    </p>
                </div>
                <div>
                    <h3>
                        {{ $t('labels.accountNumber') }}
                    </h3>
                    <p class="mt-2">
                        {{ invoicingData.accountNumber }}
                    </p>
                </div>
                <div>
                    <h3>
                        {{ $t('labels.accountName') }}
                    </h3>
                    <p class="mt-2">
                        {{ invoicingData.accountName }}
                    </p>
                </div>
                <div>
                    <h3>
                        {{ $t('labels.swiftCode') }}
                    </h3>
                    <p class="mt-2">
                        {{ invoicingData.swiftCode }}
                    </p>
                </div>
                <div>
                    <h3>
                        {{ $t('labels.address') }}
                    </h3>
                    <p class="mt-2">
                        {{ invoicingData.address }}
                    </p>
                </div>
                <div>
                    <h3>
                        {{ $t('labels.taxNumber') }}
                    </h3>
                    <p
                        v-if="invoicingData && invoicingData.phone"
                        class="mt-2">
                        {{ invoicingData.taxNumber }}
                    </p>
                </div>
                <div>
                    <h3>
                        {{ $t('labels.phone') }}
                    </h3>
                    <p class="mt-2">
                        {{ invoicingData.phone }}
                    </p>
                </div>
            </div>
        </hts-card>
        <edit-invoice
            :invoice-is-selected-to-edit="invoiceIsSelectedToEdit"
            :show="showSlideOverEditInvoice"
            :size-slide-over="30"
            @close="showSlideOverEditInvoice = false"
            @refresh="onRefresh()" />
    </div>
</template>

<script setup lang="ts">
import invoicingFormData, { IInvoicingInformation } from './ignore/imports/invoice-form'
import EditInvoice from './ignore/edit-invoice.vue'
import companyPageTabs from '@/data/company/tabs.json'

const store = $store()
const group = store.system.getGroup
const permissions = ref<Array<String>>([])
onMounted(() => {
  permissions.value = group.permissions
})
const route = useRoute()
const companyName = ref('')
const loaded = ref(false)
const showSlideOverEditInvoice = ref(false)
const invoicingData = ref<IInvoicingInformation>(invoicingFormData.initInvoice)
const invoiceIsSelectedToEdit = reactive<IInvoicingInformation>({
  name: '',
  address: '',
  accountNumber: '',
  accountName: '',
  swiftCode: '',
  taxNumber: '',
  phone: ''
})
onBeforeMount(async () => {
  route.meta.pageTabs = companyPageTabs
  await getCompanyInfo()
  companyName.value = store.system.getCompany.name
})
const dropdownOptions = [
  {
    id: 1,
    name: 'Chỉnh sửa',
    icon: 'hi-pencil-alt-icon',
    action: 'editInvoice'
  }
]
const onRefresh = async () => {
  await getCompanyInfo()
}
const handleEditInvoice = () => {
  Object.assign(invoiceIsSelectedToEdit, invoicingData.value)
  showSlideOverEditInvoice.value = true
}
const getCompanyInfo = async () => {
  loaded.value = true
  const company = await $api($urlClient.company.getHoldingCompany)
  const data: any = $lodash.get(company, 'data.value')
  const error: any = $lodash.get(company, 'error')

  if (!data.success) {
    const msgError = $lodash.get(error, 'value.data.errors.0', 'Không thể kết nối tới máy chủ')
    $toast().error(msgError)
  } else {
    invoicingData.value = data.data.invoicingInformation
  }
  loaded.value = false
}
</script>
